import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import store from "./store";
import { Auth0Provider } from "@auth0/auth0-react";
import { Provider } from "react-redux";
import axios from "axios";

import "./styles.css";
import "./custom.css";
import Loader from "./components/Loader";

axios.defaults.baseURL = process.env.REACT_APP_API;

const RootComponent = () => (
  <Provider store={store}>
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
      }}
    >
      <App />
      <Loader />
    </Auth0Provider>
  </Provider>
);

const rootDiv = ReactDOM.createRoot(document.getElementById("root"));
rootDiv.render(<RootComponent />);
